import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataTableService<T> {
  constructor() {}

  filteredItems(
    items: T[],
    searchTerm: string,
    fields: (keyof T)[],
    sortField: keyof T | null,
    sortOrder: 'asc' | 'desc' | null,
  ): T[] {
    let filtered = items;

    if (searchTerm) {
      const searchTermLower = searchTerm.toLowerCase();

      filtered = filtered.filter(item =>
        fields.some(field => {
          const fieldValue = (item[field] as string).toString()?.toLowerCase();
          return fieldValue?.includes(searchTermLower);
        }),
      );
    }

    if (sortField) {
      filtered = filtered.sort((a, b) => {
        const fieldA = a[sortField];
        const fieldB = b[sortField];

        const isAEmpty = fieldA === null || fieldA === undefined || fieldA === '';
        const isBEmpty = fieldB === null || fieldB === undefined || fieldB === '';

        if (isAEmpty && !isBEmpty) {
          return 1;
        }
        if (!isAEmpty && isBEmpty) {
          return -1;
        }

        if (sortOrder === 'asc') {
          return fieldA > fieldB ? 1 : -1;
        } else {
          return fieldA < fieldB ? 1 : -1;
        }
      });
    }

    return filtered;
  }

  sortTable(
    currentSortField: keyof T | null,
    newSortField: keyof T | null,
    currentSortOrder: 'asc' | 'desc' | null,
  ): { sortField: keyof T | null; sortOrder: 'asc' | 'desc' } {
    let sortField = currentSortField;
    let sortOrder: 'asc' | 'desc' = 'asc';

    if (currentSortField === newSortField) {
      sortOrder = currentSortOrder === 'asc' ? 'desc' : 'asc';
    } else {
      sortField = newSortField;
    }

    return { sortField, sortOrder };
  }

  getSortIcon(sortField: keyof T | null, currentField: keyof T, sortOrder: 'asc' | 'desc' | null): string {
    if (sortField === currentField) {
      return sortOrder === 'asc' ? 'fa fa-caret-up' : 'fa fa-caret-down';
    }
    return '';
  }

  /**
   * Paginate items
   * @param items - The list of items to paginate
   * @param currentPage - The current page number (1-indexed)
   * @param pageSize - Number of items per page
   * @returns The items for the current page
   */
  paginateItems(items: T[], currentPage: number, pageSize: number): T[] {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return (items || [])?.slice(startIndex, endIndex);
  }
}
